import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import DatePicker from "react-datepicker";
import moment from "moment"
// import "react-datepicker/dist/react-datepicker.css";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import TimeLineHeaders from "./TimeLineHeaders"
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import {observer} from "mobx-react"
import CalendarStore from "./CalendarStore"
import 'moment/locale/fr';

@observer
class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.getFromCalendar = this.getFromCalendar.bind(this)
    this.handleMovement = this.handleMovement.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleLeave = this.handleLeave.bind(this)
    this.state= {
      bien_id: "",
      type: "",
      cal: [],
      possibilites: [],
      currentSelect: 0,
      mouseSelected: 0,
      duration: 90,
      currentProposition: ""
    }
  }
  getFromCalendar(){
    // this.props.date
   /* axios.get("/experts/calendar/listFromCal?start="+this.props.date).then((data)=>{
      let formatted_cal = []
      data.data.events.map((calendar)=>{
        calendar.map((event)=>{
          let start = moment(event.start_time)
          let end = moment(event.end_time)
          let h_start = parseInt(start.format("H")) * 60 + parseInt(start.format("m"))
          let h_end   = parseInt(end.format("H")) * 60 + parseInt(end.format("m"))
          formatted_cal.push({h_start: h_start,h_end: h_end,summary: event.summary})

        })
      })
      this.setState({cal: formatted_cal})
    }) */
  }
  getPossibilites(){

  }
  componentDidMount(){
    let Dates = JSON.parse(this.props.demande.Dates).dates
    this.setState({possibilites: this.props.possibilites})
    this.getFromCalendar()
  }
  getInPour(hour){
    return( (100/(12*60))*(hour-7*60))
  }
  getWidth(nmbr){
    return((100/(12*60))*nmbr)
  }
  handleMovement(e){
    let x = e.clientX
    x = (x / document.documentElement.clientWidth ) *100
    let h = (420 + (x/0.138888889))

    this.setState({mouseSelected: h})

  }
  handleClick(e){
    let x = e.clientX
    x = (x / document.documentElement.clientWidth ) *100
    let h = (420 + (x/0.138888889))
    h = Math.ceil(h/5)*5;
    let proposition = moment(this.props.date,"DD/MM/YYYY").add(h,"minutes")
    this.setState({mouseSelected: 0,currentSelect: h,currentProposition: proposition.format("DD-MM-YYYY H:m")})
    CalendarStore.select(proposition.format("YYYY-MM-DDTH:m:00.000+02:00"),proposition.format("DD-MM-YYYY H:m"),this.props.date)
  }
  handleLeave(e){
    this.setState({mouseSelected: 0})

  }
  render () {
      return (
        <React.Fragment>
        <div>
          <TimeLineHeaders/>
        </div>
        <div id="timeline"style={{width: "100%",marginLeft: "auto",marginRight: "auto", height: "100px",background: "#ecf0f1"}}>
            <div  onClick={this.handleClick} onMouseLeave={this.handleLeave} onMouseMove={this.handleMovement} onClick={this.handleClick} style={{width: this.getWidth(60)+"%",left: this.getInPour(7*60)+"%",position: "absolute",background: "#ecf0f1",height: '100px'}}>
            </div>
           {this.state.possibilites.map((possibilite,index)=>(
              <div key={index} onClick={possibilite ? this.handleClick : null} onMouseLeave={this.handleLeave} onMouseMove={possibilite ? this.handleMovement : null} style={{zIndex: "1",width: this.getWidth(60)+"%",left: this.getInPour((index+8)*60)+"%",position: "absolute",background: (possibilite ? "#2ecc71" : "#2c3e50"),height: '100px'}}>
              </div>
            ))}
          {this.state.cal.map((event,index)=>(
              <div key={index} style={{zIndex: "2",pointerEvent: "none",width: this.getWidth((event.h_end-event.h_start))+"%",left: this.getInPour(event.h_start)+"%",position: "absolute",background: "#e74c3c",height: '100px'}}>
                <p className="center white-text">{event.summary}</p>
              </div>
            ))}
            <div style={{zIndex: "4",pointerEvents: "none",width: this.getWidth(CalendarStore.duration)+"%",left: this.getInPour(this.state.mouseSelected)+"%",position: "absolute",background: "rgba(52, 152, 219,0.6)",height: '100px'}}>
            </div>
            {CalendarStore.current_calendar_date == this.props.date ? (
            <div style={{zIndex: "3",pointerEvents: "none",width: this.getWidth(CalendarStore.duration)+"%",left: this.getInPour(this.state.currentSelect)+"%",position: "absolute",background: "#9b59b6",height: '100px'}}>
              {this.state.currentProposition}
            </div>
            ) : (
              <div></div>
            )}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
          />

        </React.Fragment>
      );
  }
}

export default Calendar
